import { Pipe, PipeTransform } from '@angular/core';

export type Locality = {
  carrier: number;
  locality: number;
  name: string;
};

export function localityToString(
  locality: Locality,
  format?: 'long' | 'short',
): string {
  const paddedCarrier = String(locality.carrier).padStart(5, '0');
  const paddedLocality = String(locality.locality).padStart(2, '0');
  switch (format) {
    case 'short':
      return `${paddedCarrier}${paddedLocality}`;
    default:
      return `${paddedCarrier}${paddedLocality} ${locality.name}`;
  }
}

@Pipe({ name: 'locality' })
export class LocalityPipe implements PipeTransform {
  transform(locality: Locality, format?: 'long' | 'short'): string {
    return localityToString(locality, format);
  }
}
